import { palette } from 'app_previous/styles/colors';
import styled from 'styled-components';

export const TemplateContainer = styled.div`
  max-width: 100vw !important;
  position: relative;
  overflow: hidden;
  background: ${palette.white};

  & > div.gatsby-image-wrapper {
    position: relative;
    left: -5px;
    width: calc(100% + 10px);
  }

  table.ast-table-element {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    border-style: hidden;
  }

  table.ast-table-element td,
  table.ast-table-element th {
    border-width: 1px;
    border-color: ${palette.neonSilver};
    border-style: solid;
    padding: 16px;
  }

  .ast-tbody-element {
    .ast-tr-element:nth-child(odd) {
      background-color: #f3f3f4;
    }
  }

  .ast-thead-element {
    .ast-th-element:first-child {
      text-align: left;
    }

    tr {
      background-color: ${palette.white};
    }
  }
`;

export const TemplateSpacer = styled.div`
  height: 0.5rem;
`;
